import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { NavigationStart, Router, RouterOutlet } from '@angular/router'
import { AppComponent } from 'app/app.component'
import { SignalRGlobalMessageService } from 'app/shared/generated/generated'
import { ThemeConfig } from 'app/shared/models/app-theme.model'
import { ApiService } from 'app/shared/services/api.service'
import { ThemeService } from 'app/shared/services/app-theme.service'
import { CurrentUserService } from 'app/shared/services/current-user.service'
import { MessageBusService } from 'app/shared/services/message-bus.service'
import { Subscription } from 'rxjs'
import { NgClass, NgIf } from '@angular/common';
import { ContentTopbarComponent } from './topbar/content-topbar.component';
import { AppMenuComponent } from './menu/app-menu.component';
import { ToastModule } from 'primeng/toast';
import { ContentFooterComponent } from './footer/content-footer.component';
import { ContentSidebarComponent } from './sidebar/content-sidebar.component';

@Component({
    selector: 'app-content-layout',
    templateUrl: './content-layout.component.html',
    standalone: true,
    imports: [
        NgClass,
        ContentTopbarComponent,
        AppMenuComponent,
        ToastModule,
        RouterOutlet,
        ContentFooterComponent,
        ContentSidebarComponent,
        NgIf,
    ],
})
export class ContentLayoutComponent implements AfterViewInit, OnDestroy, OnInit {
  public menuInactiveDesktop!: boolean

  public menuCollapsed: boolean = false

  public topMobileMenuActive!: boolean

  public theme!: ThemeConfig

  documentClickListener!: () => void

  menuClick!: boolean

  sideBarActive!: boolean
  public sideBarComponentToLoad?: string

  subscription!: Subscription

  constructor(
    private router: Router,
    public renderer: Renderer2,
    public app: AppComponent,
    public themeService: ThemeService,
    public messageBusService: MessageBusService,
    public apiService: ApiService,
    private signalRGlobalMessageService: SignalRGlobalMessageService,

    public currentlyAuthorizedUserService: CurrentUserService
  ) {}

  ngOnInit() {
    this.theme = this.themeService.getTheme()

    this.subscription = this.themeService.themeUpdated$.subscribe((theme: ThemeConfig) => (this.theme = theme))

    if (this.isMobile()) {
      this.menuCollapsed = true
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.hideLayoutComponents()
      }
    })

    this.currentlyAuthorizedUserService.getCurrentlyAuthorizedUser().subscribe((data) => {
      this.currentlyAuthorizedUserService.registerSignalREvents()
    })

    this.signalRGlobalMessageService.notify_register((data) => {
      this.messageBusService.addNotification(
        this.messageBusService.createMessage(data.severity, data.summary, data.detail),
        false
      )
    })
  }

  ngAfterViewInit() {
    // hides the overlay menu and top menu if outside is clicked
    this.documentClickListener = this.renderer.listen('body', 'click', (event: Event) => {
      this.hideLayoutComponents()
    })
  }

  private hideLayoutComponents() {
    if (this.isMobile()) {
      //On mobile we want to hide the menu if we click outside of it.
      this.menuCollapsed = true
      this.topMobileMenuActive = false
    }

    this.sideBarActive = false
    this.menuClick = false
  }

  isMobile() {
    return window.innerWidth < 1024
  }

  getState(outlet: any) {
    return outlet.isActivated ? outlet.activatedRoute : ''
  }

  toggleMenu(event: Event) {
    this.menuCollapsed = !this.menuCollapsed
    event.stopPropagation()
  }

  toggleSidebarDisplay(event: Event, componentToLoad?: string) {
    if (this.sideBarComponentToLoad == componentToLoad) {
      componentToLoad = undefined
    }

    this.sideBarComponentToLoad = componentToLoad
    this.sideBarActive = componentToLoad != undefined
    event.stopPropagation()
  }

  toggleMobileTopMenu(event: Event) {
    this.topMobileMenuActive = !this.topMobileMenuActive
    event.stopPropagation()
  }

  onMenuClick() {
    this.menuClick = true
  }

  ngOnDestroy() {
    if (this.documentClickListener) {
      this.documentClickListener()
    }

    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
